import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { modelAPI } from '../services/api';

const Models = () => {
  const [models, setModels] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedType, setSelectedType] = useState('all');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editingModel, setEditingModel] = useState(null);
  const [testingModel, setTestingModel] = useState(null);
  const [testResult, setTestResult] = useState({});
  const [showApiKey, setShowApiKey] = useState(false);
  const [deletingModel, setDeletingModel] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    provider: '',
    api_key_encrypted: '',
    base_url: 'https://dashscope.aliyuncs.com/api/v1',
    model_id: '',
    priority: 1,
    max_tokens: 4000,
    temperature: 0.7,
    cost_per_1k_tokens: 0,
    notes: '',
    model_type: 'text'
  });

  // SVG Icons for model types
  const TextIcon = () => (
    <svg viewBox="0 0 1024 1024" width="20" height="20" style={{ display: 'inline-block' }}>
      <path d="M903.7 296.2h-150c-16.2 0-29.4 13.1-29.4 29.4v525.6c0 16.2 13.1 29.4 29.4 29.4h150.1c16.2 0 29.4-13.1 29.4-29.4V325.6c-0.1-16.3-13.3-29.4-29.5-29.4zM104.6 98.2h608.7v777.9H104.6z" fill="#83C1FF" />
      <path d="M882.2 258.3H736.9c-18 0-32.4 14.4-32.4 32.4v507.1c0 71.4 57.6 129 129 129s129-57.6 129-129V338.7c0.1-44.4-35.9-80.4-80.3-80.4zM918.4 812c0 37.7-38.1 68.5-84.9 68.5-46.8 0-84.9-30.7-84.9-68.5V304.6H897c11.9 0 21.4 7.7 21.4 17.3V812z" fill="#FFFFFF" />
      <path d="M822.6 925.6H194.7c-71.4 0-129-57.6-129-129V144.3c0-44.4 36-80.4 80.4-80.4h525.3c44.4 0 80.4 36 80.4 80.4v640.3c0 67.2 35.4 99.7 70.2 99.7 18 0 32.4-9 32.4 9s-14.4 32.3-31.8 32.3zM126 117.1c-9.5 0-17 7.4-17 16.7v671.9c0 36.5 30.3 66.1 67.5 66.1h535.3c-11.4-21.6-17.7-48.2-17.7-78.5V133.8c0-9.3-7.6-16.7-17-16.7H126z m20.1 11" fill="#FFFFFF" />
      <path d="M587.1 596.6H235.8c-17.2 0-31-11.7-31-26.3 0-14.6 13.8-26.3 31-26.3h351.3c17.2 0 31 11.7 31 26.3 0 14.1-13.8 26.3-31 26.3zM488.2 739.4H227.8c-12.8 0-23-11.3-23-25.5s10.2-25.5 23-25.5h260.4c12.8 0 23 11.3 23 25.5-0.1 13.7-10.3 25.5-23 25.5zM618 409V263.8c0-18-14.4-32.4-32.4-32.4H237.2c-18 0-32.4 14.4-32.4 32.4v144.6c0 18 14.4 32.4 32.4 32.4h349c18 0 32.4-14.4 31.8-31.8z m-45.3-14.4H250.2V278.2h322.5v116.4z" fill="#FFFFFF" />
      <path d="M591 713.9m-24.9 0a24.9 24.9 0 1 0 49.8 0 24.9 24.9 0 1 0-49.8 0Z" fill="#FFFFFF" />
    </svg>
  );

  const ImageIcon = () => (
    <svg viewBox="0 0 1024 1024" width="20" height="20" style={{ display: 'inline-block' }}>
      <path d="M414.562 240.884c17.674 0 32 14.327 32 32 0 17.673-14.326 32-32 32H280c-48.601 0-88 39.399-88 88v302.014c0 35.382 20.881 65.886 50.992 79.863l305.335-235.124c31.506-24.261 76.714-18.388 100.975 13.118l158.369 205.659c16.698-16.016 27.095-38.551 27.095-63.516V549.966c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32v144.932c0 83.948-68.053 152-152 152H280c-83.947 0-152-68.052-152-152V392.884c0-83.947 68.053-152 152-152h134.562z m184.032 350.918a8 8 0 0 0-11.22-1.457L337.321 782.898h408.427L598.594 591.802z m-245.24-194.505c54.868 0 99.347 44.479 99.347 99.347 0 54.867-44.479 99.346-99.347 99.346-54.867 0-99.346-44.479-99.346-99.346 0-54.868 44.479-99.347 99.346-99.347z m0 64c-19.521 0-35.346 15.825-35.346 35.347 0 19.521 15.825 35.346 35.346 35.346 19.522 0 35.347-15.825 35.347-35.346 0-19.522-15.825-35.347-35.347-35.347z m323.644-251.04c13.163-40.023 69.44-40.335 83.276-0.938l0.32 0.938 18.497 56.246 56.247 18.499c40.338 13.267 40.338 70.329 0 83.596l-56.247 18.497-18.497 56.247c-13.267 40.338-70.329 40.337-83.596 0l-18.499-56.247-56.246-18.497c-40.337-13.267-40.337-70.329 0-83.596l56.246-18.499 18.499-56.246z m39.143 85.837a44.002 44.002 0 0 1-28.051 28.051l-8.074 2.655 8.074 2.655a44.002 44.002 0 0 1 28.051 28.051l2.655 8.073 2.655-8.073 0.209-0.62a44.001 44.001 0 0 1 27.842-27.431l8.073-2.655-8.073-2.655a44.004 44.004 0 0 1-28.051-28.051l-2.655-8.074-2.655 8.074z" fill="#18bc23" />
    </svg>
  );

  // Model type configurations
  const modelTypes = {
    text: {
      label: 'Text Generation',
      icon: <TextIcon />,
      color: 'blue',
      bgClass: 'bg-blue-50',
      borderClass: 'border-blue-200',
      textClass: 'text-blue-700',
      badgeClass: 'bg-blue-100 text-blue-800'
    },
    image: {
      label: 'Image Generation',
      icon: <ImageIcon />,
      color: 'purple',
      bgClass: 'bg-purple-50',
      borderClass: 'border-purple-200',
      textClass: 'text-purple-700',
      badgeClass: 'bg-purple-100 text-purple-800'
    }
  };

  useEffect(() => {
    fetchModels();
  }, []);

  useEffect(() => {
    // Filter models based on selected type
    if (selectedType === 'all') {
      setFilteredModels(models);
    } else {
      setFilteredModels(models.filter(m => m.model_type === selectedType));
    }
  }, [selectedType, models]);

  const fetchModels = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await modelAPI.getAll();
      if (response.data.success) {
        setModels(response.data.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch models:', err);
      setError('Failed to load AI models');
    } finally {
      setLoading(false);
    }
  };

  const getModelTypeConfig = (type) => {
    return modelTypes[type] || modelTypes.text;
  };

  const handleToggle = async (modelId) => {
    try {
      await modelAPI.toggle(modelId);
      fetchModels();
    } catch (err) {
      console.error('Failed to toggle model:', err);
      alert('Failed to toggle model status');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleEdit = (model) => {
    setEditingModel(model);
    setFormData({
      name: model.name || '',
      slug: model.slug || '',
      provider: model.provider || '',
      api_key_encrypted: model.api_key_encrypted || '',
      base_url: model.base_url || 'https://dashscope-intl.aliyuncs.com/api/v1',
      model_id: model.model_id || '',
      priority: model.priority || 1,
      max_tokens: model.max_tokens || 4000,
      temperature: parseFloat(model.temperature) || 0.7,
      cost_per_1k_tokens: parseFloat(model.cost_per_1k_tokens) || 0,
      notes: model.notes || '',
      model_type: model.model_type || 'text'
    });
    setShowApiKey(false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingModel(null);
    setShowApiKey(false);
    setFormData({
      name: '',
      slug: '',
      provider: '',
      api_key_encrypted: '',
      base_url: 'https://dashscope.aliyuncs.com/api/v1',
      model_id: '',
      priority: 1,
      max_tokens: 4000,
      temperature: 0.7,
      cost_per_1k_tokens: 0,
      notes: '',
      model_type: 'text'
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      let response;
      if (editingModel) {
        const updateData = { ...formData };
        if (!updateData.api_key_encrypted) {
          delete updateData.api_key_encrypted;
        }
        response = await modelAPI.update(editingModel.id, updateData);
      } else {
        response = await modelAPI.create(formData);
      }

      if (response.data.success) {
        handleCloseModal();
        fetchModels();
      }
    } catch (err) {
      console.error('Failed to save model:', err);
      setError(err.response?.data?.error?.message || 'Failed to save AI model');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTest = async (modelId) => {
    try {
      setTestingModel(modelId);
      setTestResult({ ...testResult, [modelId]: { status: 'testing' } });

      const response = await modelAPI.test(modelId);

      if (response.data.success) {
        setTestResult({
          ...testResult,
          [modelId]: {
            status: 'success',
            responseTime: response.data.data.responseTime,
            message: response.data.data.message,
            audioUrl: response.data.data.audioUrl  // Store audio URL for playback
          }
        });
      } else {
        setTestResult({
          ...testResult,
          [modelId]: {
            status: 'error',
            responseTime: response.data.data?.responseTime,
            message: response.data.data?.message || 'Test failed'
          }
        });
      }
    } catch (err) {
      console.error('Failed to test model:', err);
      setTestResult({
        ...testResult,
        [modelId]: {
          status: 'error',
          message: err.response?.data?.error?.message || 'Test failed'
        }
      });
    } finally {
      setTestingModel(null);
    }
  };

  const handleDeleteClick = (model) => {
    setDeletingModel(model);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    if (!deletingModel) return;

    try {
      await modelAPI.delete(deletingModel.id);
      setShowDeleteConfirm(false);
      setDeletingModel(null);
      fetchModels();
    } catch (err) {
      console.error('Failed to delete model:', err);
      alert('Failed to delete model: ' + (err.response?.data?.error?.message || 'Unknown error'));
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setDeletingModel(null);
  };

  // Count models by type
  const modelCounts = {
    all: models.length,
    text: models.filter(m => m.model_type === 'text').length,
    image: models.filter(m => m.model_type === 'image').length
  };

  if (loading) {
    return (
      <div className="flex h-screen bg-gray-50">
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header title="AI Models" />
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">Loading models...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="AI Models" />
        <div className="flex-1 overflow-y-auto p-6">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          {/* Top Actions and Filters */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
            <div className="flex items-center gap-3 overflow-x-auto">
              {/* Add Button */}
              <button
                onClick={() => setShowModal(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition whitespace-nowrap flex-shrink-0"
              >
                + Add AI Model
              </button>

              {/* Model Type Filter */}
              <button
                onClick={() => setSelectedType('all')}
                className={`px-4 py-2 rounded-lg font-medium transition whitespace-nowrap flex-shrink-0 ${
                  selectedType === 'all'
                    ? 'bg-indigo-100 text-indigo-800 ring-2 ring-indigo-400'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                All Models ({modelCounts.all})
              </button>
              {Object.entries(modelTypes).map(([type, config]) => (
                <button
                  key={type}
                  onClick={() => setSelectedType(type)}
                  className={`px-4 py-2 rounded-lg font-medium transition whitespace-nowrap flex-shrink-0 ${
                    selectedType === type
                      ? `${config.badgeClass} ring-2 ring-${config.color}-400`
                      : `bg-gray-100 text-gray-700 hover:bg-gray-200`
                  }`}
                >
                  {config.icon} {config.label} ({modelCounts[type]})
                </button>
              ))}
            </div>
          </div>

          {filteredModels.length === 0 ? (
            <div className="text-center py-12 bg-white rounded-lg">
              <p className="text-gray-500">
                {selectedType === 'all'
                  ? 'No AI models found'
                  : `No ${modelTypes[selectedType]?.label} models found`
                }
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredModels.map((model) => {
                const typeConfig = getModelTypeConfig(model.model_type);
                return (
                  <div
                    key={model.id}
                    className={`bg-white rounded-lg shadow-sm border-2 ${typeConfig.borderClass} p-6 hover:shadow-md transition-shadow`}
                  >
                    {/* Header with Model Type Badge */}
                    <div className="flex items-center justify-between mb-3">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold ${typeConfig.badgeClass} flex items-center gap-1`}>
                        <span>{typeConfig.icon}</span>
                        <span>{typeConfig.label}</span>
                      </span>
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        model.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                      }`}>
                        {model.is_active ? '● Active' : '○ Inactive'}
                      </span>
                    </div>

                    {/* Model Name */}
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{model.name}</h3>

                    {/* Provider and Model ID */}
                    <div className={`${typeConfig.bgClass} rounded-lg p-3 mb-4`}>
                      <p className="text-sm font-semibold text-gray-700">{model.provider || 'N/A'}</p>
                      <p className="text-xs text-gray-600 font-mono mt-1">{model.model_id || 'N/A'}</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-2 mb-4">
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">Priority</span>
                        <span className="font-semibold">{model.priority || 0}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">Max Tokens</span>
                        <span className="font-semibold">{(model.max_tokens || 0).toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">Cost/1K</span>
                        <span className="font-semibold">${model.cost_per_1k_tokens || 0}</span>
                      </div>
                    </div>

                    {/* Notes */}
                    <div className="mb-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
                      <p className="text-xs font-semibold text-gray-700 mb-1">Notes:</p>
                      <p className="text-sm text-gray-600">
                        {model.notes || <span className="text-gray-400 italic">No notes available</span>}
                      </p>
                    </div>

                    {/* Test Result */}
                    <div className="mb-4">
                      {testResult[model.id] ? (
                        <div className={`w-full p-3 rounded-lg text-sm ${
                          testResult[model.id].status === 'success'
                            ? 'bg-green-50 border border-green-200 text-green-800'
                            : testResult[model.id].status === 'error'
                            ? 'bg-red-50 border border-red-200 text-red-700'
                            : 'bg-blue-50 border border-blue-200 text-blue-700'
                        }`}>
                          {testResult[model.id].status === 'testing' ? (
                            <div className="flex items-center">
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                              Testing...
                            </div>
                          ) : (
                            <div>
                              <div className="font-semibold mb-1">
                                {testResult[model.id].status === 'success' ? '✓ Test Passed' : '✗ Test Failed'}
                              </div>
                              {testResult[model.id].responseTime && (
                                <div className="text-xs">Time: {testResult[model.id].responseTime}ms</div>
                              )}
                              {testResult[model.id].message && (
                                <div className="text-xs mt-1">
                                  {testResult[model.id].message.includes('http') ? (
                                    // If message contains URL, extract and display it nicely
                                    (() => {
                                      const urlMatch = testResult[model.id].message.match(/(https?:\/\/[^\s,)]+)/);
                                      const url = urlMatch ? urlMatch[0] : '';
                                      const textBefore = testResult[model.id].message.substring(0, testResult[model.id].message.indexOf(url));

                                      return (
                                        <div>
                                          <div className="mb-1">{textBefore}</div>
                                          <a
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-flex items-center gap-1 px-2 py-1 bg-white rounded border border-blue-300 text-blue-600 hover:bg-blue-50 hover:border-blue-400 transition text-xs font-medium"
                                          >
                                            <svg viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3">
                                              <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                              <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                                            </svg>
                                            View Image
                                          </a>
                                        </div>
                                      );
                                    })()
                                  ) : (
                                    // Regular text message
                                    <span className="line-clamp-2">{testResult[model.id].message}</span>
                                  )}
                                </div>
                              )}

                              {/* Audio Player for Speech Synthesis models */}
                              {model.model_type === 'speech' && testResult[model.id].audioUrl && testResult[model.id].status === 'success' && (
                                <div className="mt-3 bg-white rounded-lg p-3 border border-green-300">
                                  <div className="flex items-center gap-2 mb-2">
                                    <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                                      <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z" clipRule="evenodd" />
                                    </svg>
                                    <span className="text-xs font-medium text-green-700">Test Audio:</span>
                                  </div>
                                  <audio
                                    controls
                                    className="w-full h-8"
                                    style={{ maxHeight: '32px' }}
                                    src={`${process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://api.getaizest.com'}${testResult[model.id].audioUrl}`}
                                  >
                                    Your browser does not support the audio element.
                                  </audio>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="w-full text-center text-xs text-gray-400 py-4">
                          Click Test to verify
                        </div>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div className="grid grid-cols-3 gap-2 mb-2">
                      <button
                        onClick={() => handleTest(model.id)}
                        disabled={testingModel === model.id || !model.is_active}
                        className={`py-2 rounded-lg text-sm font-medium transition ${
                          testingModel === model.id
                            ? 'bg-blue-200 text-blue-900 cursor-wait'
                            : 'bg-blue-100 text-blue-800 hover:bg-blue-200 disabled:opacity-50 disabled:cursor-not-allowed'
                        }`}
                      >
                        {testingModel === model.id ? 'Testing...' : 'Test'}
                      </button>
                      <button
                        onClick={() => handleEdit(model)}
                        className="py-2 border-2 border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleToggle(model.id)}
                        className={`py-2 rounded-lg text-sm font-medium transition ${
                          model.is_active
                            ? 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200'
                            : 'bg-green-100 text-green-800 hover:bg-green-200'
                        }`}
                      >
                        {model.is_active ? 'Disable' : 'Enable'}
                      </button>
                    </div>

                    <button
                      onClick={() => handleDeleteClick(model)}
                      className="w-full py-2 bg-red-100 text-red-800 rounded-lg text-sm font-medium hover:bg-red-200 transition"
                    >
                      Delete
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Add/Edit Model Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">
                {editingModel ? 'Edit AI Model' : 'Add AI Model'}
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              {/* Model Type Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Model Type *
                </label>
                <div className="grid grid-cols-2 gap-4">
                  {Object.entries(modelTypes).map(([type, config]) => (
                    <button
                      key={type}
                      type="button"
                      onClick={() => {
                        setFormData({ ...formData, model_type: type });
                      }}
                      className={`p-4 rounded-lg border-2 text-center transition ${
                        formData.model_type === type
                          ? `${config.borderClass} ${config.bgClass} ${config.textClass} font-semibold`
                          : 'border-gray-200 bg-white hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex justify-center mb-2" style={{ fontSize: '32px' }}>
                        {React.cloneElement(config.icon, { width: 32, height: 32 })}
                      </div>
                      <div className="text-sm font-medium">{config.label}</div>
                    </button>
                  ))}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Model Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="e.g., GPT-4"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Slug
                  </label>
                  <input
                    type="text"
                    name="slug"
                    value={formData.slug}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="e.g., gpt-4 (optional)"
                  />
                </div>
              </div>

              {/* Conditional fields based on model type */}
              {formData.model_type === 'speech' ? (
                // Speech Synthesis specific fields
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Provider *
                    </label>
                    <select
                      name="provider"
                      value={formData.provider}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      required
                    >
                      <option value="">Select Provider</option>
                      <option value="Qwen">Alibaba Cloud Qwen TTS</option>
                      <option value="ElevenLabs">ElevenLabs</option>
                      <option value="OpenAI">OpenAI TTS</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Base URL *
                      </label>
                      <select
                        name="base_url"
                        value={formData.base_url}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        required
                      >
                        <option value="https://dashscope.aliyuncs.com/api/v1">Beijing (China)</option>
                        <option value="https://dashscope-intl.aliyuncs.com/api/v1">Singapore (International)</option>
                      </select>
                      <p className="mt-1 text-xs text-gray-500">
                        API region endpoint
                      </p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Model *
                      </label>
                      <input
                        type="text"
                        name="model_id"
                        value={formData.model_id}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="qwen3-tts-flash"
                        required
                      />
                      <p className="mt-1 text-xs text-gray-500">
                        Qwen TTS model name
                      </p>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      API Key *
                    </label>
                    <div className="relative">
                      <input
                        type={showApiKey ? "text" : "password"}
                        name="api_key_encrypted"
                        value={formData.api_key_encrypted}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder={editingModel ? "Leave blank to keep current key" : "Enter Alibaba Cloud API Key"}
                        required={!editingModel}
                      />
                      {formData.api_key_encrypted && (
                        <button
                          type="button"
                          onClick={() => setShowApiKey(!showApiKey)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                          {showApiKey ? (
                            <svg viewBox="0 0 1024 1024" width="20" height="20" style={{ display: 'inline-block' }}>
                              <path d="M332.8 729.6l34.133333-34.133333c42.666667 12.8 93.866667 21.333333 145.066667 21.333333 162.133333 0 285.866667-68.266667 375.466667-213.333333-46.933333-72.533333-102.4-128-166.4-162.133334l29.866666-29.866666c72.533333 42.666667 132.266667 106.666667 183.466667 192-98.133333 170.666667-243.2 256-426.666667 256-59.733333 4.266667-119.466667-8.533333-174.933333-29.866667z m-115.2-64c-51.2-38.4-93.866667-93.866667-132.266667-157.866667 98.133333-170.666667 243.2-256 426.666667-256 38.4 0 76.8 4.266667 110.933333 12.8l-34.133333 34.133334c-25.6-4.266667-46.933333-4.266667-76.8-4.266667-162.133333 0-285.866667 68.266667-375.466667 213.333333 34.133333 51.2 72.533333 93.866667 115.2 128l-34.133333 29.866667z m230.4-46.933333l29.866667-29.866667c8.533333 4.266667 21.333333 4.266667 29.866666 4.266667 46.933333 0 85.333333-38.4 85.333334-85.333334 0-12.8 0-21.333333-4.266667-29.866666l29.866667-29.866667c12.8 17.066667 17.066667 38.4 17.066666 64 0 72.533333-55.466667 128-128 128-17.066667-4.266667-38.4-12.8-59.733333-21.333333zM384 499.2c4.266667-68.266667 55.466667-119.466667 123.733333-123.733333 0 4.266667-123.733333 123.733333-123.733333 123.733333zM733.866667 213.333333l29.866666 29.866667-512 512-34.133333-29.866667L733.866667 213.333333z" fill="#444444" />
                            </svg>
                          ) : (
                            <svg viewBox="0 0 1024 1024" width="20" height="20" style={{ display: 'inline-block' }}>
                              <path d="M512 298.666667c-162.133333 0-285.866667 68.266667-375.466667 213.333333 89.6 145.066667 213.333333 213.333333 375.466667 213.333333s285.866667-68.266667 375.466667-213.333333c-89.6-145.066667-213.333333-213.333333-375.466667-213.333333z m0 469.333333c-183.466667 0-328.533333-85.333333-426.666667-256 98.133333-170.666667 243.2-256 426.666667-256s328.533333 85.333333 426.666667 256c-98.133333 170.666667-243.2 256-426.666667 256z m0-170.666667c46.933333 0 85.333333-38.4 85.333333-85.333333s-38.4-85.333333-85.333333-85.333333-85.333333 38.4-85.333333 85.333333 38.4 85.333333 85.333333 85.333333z m0 42.666667c-72.533333 0-128-55.466667-128-128s55.466667-128 128-128 128 55.466667 128 128-55.466667 128-128 128z" fill="#444444" />
                            </svg>
                          )}
                        </button>
                      )}
                    </div>
                    <p className="mt-1 text-xs text-gray-500">
                      Alibaba Cloud API Key. Get it from <a href="https://help.aliyun.com/zh/model-studio/get-api-key" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">DashScope Console</a>
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Default Speed
                      </label>
                      <select
                        name="temperature"
                        value={formData.temperature}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        <option value="0">Normal Speed</option>
                        <option value="1">Slow Speed</option>
                      </select>
                      <p className="mt-1 text-xs text-gray-500">
                        Default speech rate (can be changed per request)
                      </p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Priority
                      </label>
                      <input
                        type="number"
                        name="priority"
                        value={formData.priority}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        min="1"
                        max="100"
                      />
                      <p className="mt-1 text-xs text-gray-500">
                        Higher priority models are used first
                      </p>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Supported Voices
                    </label>
                    <div className="grid grid-cols-3 gap-2">
                      {['Cherry', 'Shiyu', 'Qingqing', 'Longyuan', 'Zhifeng'].map(voice => (
                        <div key={voice} className="flex items-center">
                          <input
                            type="checkbox"
                            id={`voice-${voice}`}
                            defaultChecked
                            className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                          />
                          <label htmlFor={`voice-${voice}`} className="ml-2 text-xs text-gray-700">
                            {voice}
                          </label>
                        </div>
                      ))}
                    </div>
                    <p className="mt-1 text-xs text-gray-500">
                      Chinese neural voices available for this model
                    </p>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="flex items-start">
                      <svg className="w-5 h-5 text-blue-600 mt-0.5 mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      <div className="text-sm text-blue-800">
                        <p className="font-medium mb-1">Qwen3-TTS-Flash Configuration</p>
                        <p className="text-xs mb-2">
                          Latest qwen3-tts-flash model with faster response time. Configure your Alibaba Cloud API Key to enable high-quality Chinese neural voices.
                        </p>
                        <ul className="text-xs space-y-1">
                          <li>• <strong>Model:</strong> qwen3-tts-flash (recommended)</li>
                          <li>• <strong>Region:</strong> Singapore (International) or Beijing (China)</li>
                          <li>• <strong>Voices:</strong> 5 Chinese neural voices (Cherry, Shiyu, Qingqing, Longyuan, Zhifeng)</li>
                          <li>• <strong>SDK:</strong> DashScope >= 1.24.6</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                // Text/Image generation fields (original fields)
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Provider *
                    </label>
                    <select
                      name="provider"
                      value={formData.provider}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      required
                    >
                      <option value="">Select Provider</option>
                      <option value="deepseek">Deepseek</option>
                      <option value="doubao">Doubao (ByteDance)</option>
                      <option value="bailian">Bailian (Alibaba)</option>
                      <option value="openai">OpenAI</option>
                      <option value="anthropic">Anthropic</option>
                      <option value="elevenlabs">ElevenLabs</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      API Key {!editingModel && '*'}
                    </label>
                    <div className="relative">
                      <input
                        type={showApiKey ? "text" : "password"}
                        name="api_key_encrypted"
                        value={formData.api_key_encrypted}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder={editingModel ? "Leave blank to keep current key" : "Enter API key"}
                        required={!editingModel}
                      />
                      {formData.api_key_encrypted && (
                        <button
                          type="button"
                          onClick={() => setShowApiKey(!showApiKey)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                          {showApiKey ? (
                            <svg viewBox="0 0 1024 1024" width="20" height="20" style={{ display: 'inline-block' }}>
                              <path d="M332.8 729.6l34.133333-34.133333c42.666667 12.8 93.866667 21.333333 145.066667 21.333333 162.133333 0 285.866667-68.266667 375.466667-213.333333-46.933333-72.533333-102.4-128-166.4-162.133334l29.866666-29.866666c72.533333 42.666667 132.266667 106.666667 183.466667 192-98.133333 170.666667-243.2 256-426.666667 256-59.733333 4.266667-119.466667-8.533333-174.933333-29.866667z m-115.2-64c-51.2-38.4-93.866667-93.866667-132.266667-157.866667 98.133333-170.666667 243.2-256 426.666667-256 38.4 0 76.8 4.266667 110.933333 12.8l-34.133333 34.133334c-25.6-4.266667-46.933333-4.266667-76.8-4.266667-162.133333 0-285.866667 68.266667-375.466667 213.333333 34.133333 51.2 72.533333 93.866667 115.2 128l-34.133333 29.866667z m230.4-46.933333l29.866667-29.866667c8.533333 4.266667 21.333333 4.266667 29.866666 4.266667 46.933333 0 85.333333-38.4 85.333334-85.333334 0-12.8 0-21.333333-4.266667-29.866666l29.866667-29.866667c12.8 17.066667 17.066667 38.4 17.066666 64 0 72.533333-55.466667 128-128 128-17.066667-4.266667-38.4-12.8-59.733333-21.333333zM384 499.2c4.266667-68.266667 55.466667-119.466667 123.733333-123.733333 0 4.266667-123.733333 123.733333-123.733333 123.733333zM733.866667 213.333333l29.866666 29.866667-512 512-34.133333-29.866667L733.866667 213.333333z" fill="#444444" />
                            </svg>
                          ) : (
                            <svg viewBox="0 0 1024 1024" width="20" height="20" style={{ display: 'inline-block' }}>
                              <path d="M512 298.666667c-162.133333 0-285.866667 68.266667-375.466667 213.333333 89.6 145.066667 213.333333 213.333333 375.466667 213.333333s285.866667-68.266667 375.466667-213.333333c-89.6-145.066667-213.333333-213.333333-375.466667-213.333333z m0 469.333333c-183.466667 0-328.533333-85.333333-426.666667-256 98.133333-170.666667 243.2-256 426.666667-256s328.533333 85.333333 426.666667 256c-98.133333 170.666667-243.2 256-426.666667 256z m0-170.666667c46.933333 0 85.333333-38.4 85.333333-85.333333s-38.4-85.333333-85.333333-85.333333-85.333333 38.4-85.333333 85.333333 38.4 85.333333 85.333333 85.333333z m0 42.666667c-72.533333 0-128-55.466667-128-128s55.466667-128 128-128 128 55.466667 128 128-55.466667 128-128 128z" fill="#444444" />
                            </svg>
                          )}
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Base URL *
                      </label>
                      <input
                        type="url"
                        name="base_url"
                        value={formData.base_url}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="https://api.example.com"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Model ID *
                      </label>
                      <input
                        type="text"
                        name="model_id"
                        value={formData.model_id}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="e.g., deepseek-chat"
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Priority
                      </label>
                      <input
                        type="number"
                        name="priority"
                        value={formData.priority}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        min="1"
                        max="100"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Max Tokens
                      </label>
                      <input
                        type="number"
                        name="max_tokens"
                        value={formData.max_tokens}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        min="1"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Temperature
                      </label>
                      <input
                        type="number"
                        name="temperature"
                        value={formData.temperature}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        step="0.1"
                        min="0"
                        max="2"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Cost per 1K Tokens ($)
                      </label>
                      <input
                        type="number"
                        name="cost_per_1k_tokens"
                        value={formData.cost_per_1k_tokens}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        step="0.0000001"
                        min="0"
                        lang="en"
                        title="Please enter a valid value. The value must be in increments of 0.0000001"
                      />
                    </div>
                  </div>
                </>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Notes
                </label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows="3"
                  placeholder="Add any additional notes or remarks about this model"
                />
              </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {isSubmitting
                    ? (editingModel ? 'Updating...' : 'Creating...')
                    : (editingModel ? 'Update Model' : 'Create Model')
                  }
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && deletingModel && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Confirm Delete</h2>
            <p className="text-gray-700 mb-2">
              Are you sure you want to permanently delete the following AI model?
            </p>
            <div className="bg-gray-50 p-3 rounded-lg mb-6">
              <p className="font-semibold text-gray-900">{deletingModel.name}</p>
              <p className="text-sm text-gray-600">{deletingModel.provider} - {deletingModel.model_id}</p>
            </div>
            <p className="text-sm text-red-600 font-semibold mb-6">
              ⚠️ Warning: This action cannot be undone.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={handleDeleteCancel}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Delete Model
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Models;
